import { Store } from 'src/store/index';

const getCanDesignBeSaved = (store: Store) => store.design.errors.length === 0;

export default getCanDesignBeSaved;
